/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define([], function() {

    function errorHandler(err) {
        if (Object.prototype.toString.call(err) === '[object String]') {
            try {
                err = JSON.parse(err);
                this.fail(err);
            } catch (e) {
                this.fail(err);
            }
        }
        this.fail(err);
    }

    return function(options, req) {
        var errHandler = errorHandler.bind(options);
        if (options.fail) {
            req.on('error', errHandler)
                .on('4xx', errHandler)
                .on('5xx', errHandler);
        }
        return req;
    };
});



// WEBPACK FOOTER //
// ./requester/errorHandlerJsnop.js